import React, { useState } from "react";

import LocationIcon from "../../../images/icons/location-icon.inline.svg";
import { Link } from "../../../utils/customLink";
import GviFlexTestimonialRating from "../../cards/gviFlexTestimonialRating";
import Image from "../../image";
import ProgramSummaryDetails from "../programSummaryDetails";

const ProgramHeaderStrip = ({
  programProviderBio,
  programDuration,
  programLocation,
  programTypeList,
  programTypes,
  programPopular,
  programCapacity,
  carbonFootprintStatus,
  fundSpendingStatus,
  currentBrand,
  programCode = "",
  containerClass = "flex flex-row flex-wrap gap-y-4 gap-x-10 sm:gap-2 sm:items-center",
  summaryBlockItemTextClass = "text-white",
  summaryBlockItemSpacingClass = "py-2 sm:py-0",
  sdgIcons = [],
  scrollToReviews = () => {}
}) => {
  const [reviewsCount, setReviewsCount] = useState(0);
  return (
    <div className={containerClass}>
      <ProgramSummaryDetails
        programCode={programCode}
        programDuration={programDuration}
        programTypeList={programTypeList}
        programTypes={programTypes}
        programPopular={programPopular}
        programCapacity={programCapacity}
        currentBrand={currentBrand}
        carbonFootprintStatus={carbonFootprintStatus}
        summaryDetailsClass={"flex gap-1 sm:gap-8 w-auto"}
        textColorClass="text-black-lighter dark:text-white font-normal"
        textSecondaryColorClass="text-black-lighter dark:text-white font-bold"
        iconClass="w-4 h-4 fill-black-lighter dark:fill-white"
        imageIconClass=""
        programRatingDarkRatingIconClass="hidden sm:block h-5 w-auto fill-black-lighter dark:fill-white"
        programRatingDarkRatingLogoClass="w-auto h-5 fill-black-lighter dark:fill-white"
        sdgIcons={sdgIcons}
        scrollToReviews={scrollToReviews}
        showFieldworkHours={true}
        showParticipantRatio={false}
        showExperiences={false}
        showTrustPilot={false}
        showProgramCapacity={false}
        showTestimonialRating={false}
        showFundraisingSummary={false}
        summaryBlockItemTextClass={summaryBlockItemTextClass}
        summaryBlockItemSpacingClass={summaryBlockItemSpacingClass}
        fundSpendingStatus={fundSpendingStatus}
      />

      <GviFlexTestimonialRating
        programCode={programCode}
        currentBrand={currentBrand}
        expandedScoreContainerClass="text-base font-normal text-black-lighter dark:text-gray-dark"
        expandedCountContainerClass="text-base font-normal text-black-lighter dark:text-gray-dark"
        containerClass="flex gap-2 sm:gap-2 icon-wrapper justify-items-center items-center w-full sm:w-auto pr-5 sm:px-5"
        iconClass="w-4 h-4 fill-black-lighter dark:fill-white"
        descClass="text-black-lighter dark:text-white"
        layout="flex-compact"
        reviewsCount={reviewsCount}
        setReviewsCount={setReviewsCount}
      />

      {sdgIcons?.map((sdgIcon, idx) => {
        return (
          <div
            key={`sdgIcon-${idx}`}
            className={`flex gap-2 sm:gap-3 icon-wrapper justify-items-center items-center text-black-lighter dark:text-white w-1/3 sm:w-auto sm:pl-4`}
          >
            <Image
              imageClass={
                "w-7 h-7 block object-cover object-center bg-white dark:bg-gray-dark"
              }
              image={sdgIcon?.icon}
              sourceUrl={sdgIcon?.icon?.sourceUrl}
            />
            <div
              className="text-black-lighter dark:text-white uppercase font-bold"
              dangerouslySetInnerHTML={{
                __html: ["sdg", sdgIcon?.title].join(" ")
              }}
            />
          </div>
        );
      })}
      <div className="flex gap-2 sm:gap-3 icon-wrapper justify-items-center items-center sm:hidden">
        <LocationIcon className="w-4 h-4 fill-gray-standard dark:fill-white" />
        {programLocation &&
          programLocation.length > 0 &&
          programLocation
            ?.slice(1)
            ?.reverse()
            ?.map((nav, index) => (
              <React.Fragment key={`program-location-${index}`}>
                {nav?.text && nav?.toPage && (
                  <div
                    key={`program-location-nav-${index}`}
                    className="flex flex-row justify-start md:justify-center"
                  >
                    <Link
                      className="text-generic-text dark:text-white program-location underline underline-offset-4"
                      to={nav.toPage}
                    >
                      {index === programLocation.length - 2
                        ? `${nav.text}`
                        : `${nav.text}, `}
                    </Link>
                  </div>
                )}
              </React.Fragment>
            ))}
      </div>
    </div>
  );
};

export default ProgramHeaderStrip;
